import { render, staticRenderFns } from "./AppInfoModal.vue?vue&type=template&id=52b09fe3&scoped=true&"
import script from "./AppInfoModal.vue?vue&type=script&lang=js&"
export * from "./AppInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./AppInfoModal.vue?vue&type=style&index=0&id=52b09fe3&prod&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b09fe3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconInfo: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconInfo.vue').default,SvgIconClose: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconClose.vue').default})
